import { Observable } from "rxjs/Observable";
import * as actions from "./contact.actions";
import { Contact } from "./contact.model";
import { RestrictedAccountObjectStoreFacade } from "../restricted-account-object/restricted-account-object.store-facade";
import { ContactType } from "../contact-type/contact-type.model";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { Qry } from "../query-facade";

export class ContactStoreFacade extends RestrictedAccountObjectStoreFacade<Contact> {

    getAll(): Observable<Array<Contact>> {
        return this.select(Qry.getInstance().contact.byActiveAccount);
    }

    getFiltered(): Observable<Array<Contact>> {
        return this.select(Qry.getInstance().contact.filtered);
    }

    create(contact: Contact): void {
        this.dispatch(new actions.SubmitAction(contact));
    }

    update(contact: Contact): void {
        this.dispatch(new actions.SubmitAction(contact));
    }

    insert(contact: Contact): void {
        this.dispatch(new actions.SubmitAction(contact, {persistable: true, restful: false}));
    }

    remove(contact: Contact, options?: ActionOptionsArgs): void {
        this.checkCanDelete(contact);
        this.dispatch(new actions.RemoveAction(contact, options));
    }

    removeByContactType(contactType: ContactType, options?: ActionOptionsArgs): void {
        this.removeBy(contact => contact.contactType === contactType.id, options);
    }

    setFilters(filters): void {
        this.dispatch(new actions.SetFilterAction(filters));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/contact/contact.store-facade.ts